import type { GetTeamAvatarColorParams } from './teamSelectModal.types';

export const getTeamAvatarColor = ({ team, theme, hasLogo }: GetTeamAvatarColorParams) => {
  if (hasLogo) {
    return 'transparent';
  }

  if (team.brand) {
    return theme.palette.custom.teceo.green;
  }

  if (team.store) {
    return theme.palette.custom.teceo.blue;
  }

  return theme.palette.custom.teceo.orange;
};
